import React, { useContext, useState } from "react";
import { TokenContext } from "./TokenProvider";
import { AppBar, Grid, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
const logo = require('./logo.svg').default;

const createUrl = (path: string) => new URL(`${document.location.origin}/minerva-service/v1/${path}`);

export const ResetCache = () => {
    const token = useContext(TokenContext);
    const [resp, setResp] = useState('')
    const [dialogTitle, setDialogTitle] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    return token ? (
        <>
            <Dialog open={showDialog}>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent>
                    {resp ? <Typography>{resp}</Typography> : null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setShowDialog(false) }}>Close</Button>
                </DialogActions>
            </Dialog>
            <AppBar position="fixed" color="primary" style={{ backgroundColor: '#516FA3' }}>
                <Toolbar>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                            <img src={logo} alt="Vegas.com logo" />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">Help Search</Typography>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <div style={{ marginTop: '6em' }}>
                <Typography>Resetting the cache will refresh the Minerva cache to allow new documentation to be loaded.</Typography>
                {!showLoading ? <Button variant={"contained"} onClick={(e) => {
                    e.preventDefault();
                    setShowLoading(true);
                    fetch(createUrl('reset-cache'), {
                        method: 'put',
                        headers: { authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (!res.ok) {
                            setShowDialog(true);
                            setDialogTitle(`${res.status} ${res.statusText}`)
                            setResp(`${await res.text()}`);
                        } else {
                            setShowDialog(true);
                            setDialogTitle('Success');
                            setResp('The cache was successfully refreshed.')
                        }

                        setShowLoading(false);
                    }, async (err) => {
                        setShowDialog(true);
                        setDialogTitle('Request failure');
                        setResp(`${err}`);
                        setShowLoading(false);
                    });
                }}>Reset cache</Button> : <CircularProgress />}
            </div>

        </>
    ) : (<>Unauthorized</>)
}